import React, { useEffect, useState } from "react";
import { api, formatError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Bell, BellRing } from "lucide-react";
import { toast } from "sonner";

export default function FollowDeityButton({ slug, name }) {
  const { user } = useAuth();
  const [state, setState] = useState({ followers: 0, following: false });
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(false);
  const load = () => api.get(`/follows/count/${slug}`).then((r) => setState(r.data)).catch(() => {});
  useEffect(() => { load(); }, [slug, user]); // eslint-disable-line react-hooks/exhaustive-deps

  const follow = async (e) => {
    e?.preventDefault();
    try {
      const { data } = await api.post("/follows", { slug, email: user ? null : email });
      setState({ followers: data.followers, following: Boolean(user) || state.following });
      toast.success(`You'll get an email 3 days before ${name}'s festivals`);
      setOpen(false);
    } catch (err) { toast.error(formatError(err)); }
  };
  const unfollow = async () => {
    try { await api.delete(`/follows/${slug}`); toast.success("Unfollowed"); load(); } catch (err) { toast.error(formatError(err)); }
  };

  const count = <span className="text-xs opacity-70 ml-1">{" "}· {state.followers}</span>;
  if (user) {
    return state.following
      ? <button data-testid="deity-unfollow-btn" onClick={unfollow} className="btn-ghost-gold text-sm"><BellRing className="w-4 h-4" /> Following{count}</button>
      : <button data-testid="deity-follow-btn" onClick={follow} className="btn-ghost-gold text-sm"><Bell className="w-4 h-4" /> Follow festival alerts{count}</button>;
  }
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid="deity-follow-btn" className="btn-ghost-gold text-sm"><Bell className="w-4 h-4" /> Follow festival alerts{count}</button>
      </PopoverTrigger>
      <PopoverContent className="bg-[#FFFDF9] border-[#D4AF37]/40 w-80">
        <form onSubmit={follow} className="space-y-3">
          <div className="text-sm text-[#4A0E17]">Get an email 3 days before every <b>{name}</b> festival. You can unsubscribe in one click.</div>
          <Input data-testid="follow-email" type="email" required placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-white border-[#D4AF37]/40 h-10" />
          <Button data-testid="follow-email-submit" className="w-full bg-[#4A0E17] hover:bg-[#36080F] rounded-full h-10">Follow {name}</Button>
        </form>
      </PopoverContent>
    </Popover>
  );
}
